import * as PIXI from "pixi.js";
import { Resource } from "nova_ecs/resource";


export const PixiAppResource = new Resource<PIXI.Application>('PixiAppResource');
